import { Component, OnInit } from '@angular/core';
import { CommonDataService } from '../../common/services/common-data.service';
import { GraphqlService } from '../../common/services/graphql.service';

@Component({
  selector: 'app-acronyms',
  templateUrl: './acronyms.component.html'
})
export class AcronymsComponent implements OnInit {

  constructor(private commonDataService: CommonDataService, private graphQLservice: GraphqlService) { }
  stt_Acronym_header
  stt_Acronym_subtitle_description
  stt_Acronym_Table_header =[]
  stt_Acronyms
  stt_acronymsdisplay: { key: string, value: string }[] = [];
  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);

    this.getPageContent();
  }
  getPageContent() {
    this.graphQLservice.getAcroynmLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.stt_Acronym_header = labels.filter(x => x.key == "stt_Acronym_header").map(y => y.value);
        this.stt_Acronym_subtitle_description = labels.filter(x => x.key == "stt_Acronym_subtitle_description").map(y => y.value);
        this.stt_Acronym_Table_header = labels.filter(x => x.key == "stt_Acronym_Table_header").map(y => y.value)[0].split(":");

        this.stt_Acronyms = labels.filter(x => x.key == "stt_Acronyms").map(y => y.value);
        let acronym_arr = this.stt_Acronyms[0].split(";").map(d => d.split(":"));
        acronym_arr.forEach(d => {

          this.stt_acronymsdisplay.push({ key: d[0], value: d[1] });

        });
        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }

}
